<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// Main App component
</script>

<style scoped>
#app {
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}
</style>
